<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  value: { type: Boolean, required: true },
  loading: { type: Boolean, default: false }
})

const store = useStore()

const loading = computed(() => store.state.reinforcement.deleteAllLoading)
</script>

<template>
  <v-dialog :model-value="value" max-width="400" @click:outside="$emit('close')">
    <v-card>
      <v-card-title class="pt-4">Delete all reinforcements</v-card-title>
      <v-card-text class="pt-0 pl-4">
        Are you sure you want to delete all reinforcements?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :loading="loading" @click="$emit('delete')" variant="flat" color="error">
          Delete all reinforcements
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
